/**
 * XML Minify Tool
 *
 * Minify XML by removing whitespace between tags.
 */

import { XMLBuilder,XMLParser } from 'fast-xml-parser';

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import { ToolError } from '@/engine/errors/ToolError';
import type { ITransformerTool } from '@/interfaces/ITool';

export const XmlMinifyTool: ITransformerTool = {
  id: 'xml-minify',
  name: 'XML Minify',
  description: 'Minify XML by removing whitespace between tags',
  version: '1.0.0',
  type: 'transformer',
  category: 'Formatters & Minifiers',
  keywords: ['xml', 'minify', 'compress', 'compact'],

  seo: {
    slug: 'xml-minifier',
    pageTitle: 'XML Minifier - Free Online Tool | Prism',
    metaDescription: 'Minify XML by removing unnecessary whitespace and line breaks. Reduce XML file size instantly. Fast, private, runs entirely in your browser.',
    keywords: ['xml minifier', 'minify xml online', 'xml compress', 'xml compact', 'remove xml whitespace'],
    relatedTools: ['xml-format', 'xml-validate', 'xml-to-json'],
    schemaType: 'WebApplication',
  },

  supportedInputTypes: [SEMANTIC_TYPES.XML, SEMANTIC_TYPES.TEXT],
  outputType: SEMANTIC_TYPES.XML,

  attributes: [],

  async transform(input: string): Promise<string> {
    const text = String(input ?? '').trim();
    if (!text) return '';

    try {
      const parser = new XMLParser({
        ignoreAttributes: false,
        attributeNamePrefix: '@_',
        textNodeName: '#text',
        allowBooleanAttributes: true,
        preserveOrder: true,
        commentPropName: '#comment',
        cdataPropName: '#cdata',
        processEntities: false,
        trimValues: true,
      });

      const parsed = parser.parse(text);

      const builder = new XMLBuilder({
        ignoreAttributes: false,
        attributeNamePrefix: '@_',
        textNodeName: '#text',
        format: false,
        preserveOrder: true,
        commentPropName: '#comment',
        cdataPropName: '#cdata',
        processEntities: false,
        suppressEmptyNode: false,
      });

      const result = builder.build(parsed) as string;
      return result.trim();
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Failed to minify XML';
      throw ToolError.execution(message);
    }
  },
};
